/* eslint-disable no-unused-vars */
import Swiper from 'swiper/js/swiper';
import '~/sass/pages/rights.scss';

const { $ } = window;

function navScrollToFixed() {
  let beltH = null;
  const wW = $(window).width();
  if (wW < 1024) {
    beltH = 50;
    $('body').attr('data-offset', beltH);
  } else {
    beltH = 60;
    $('body').attr('data-offset', 270);
  }

  $('#global-header').scrollToFixed({
    limit: $('#belt').offset().top - $('#global-header').height(),
    zIndex: 99999,
  });

  $('#belt').scrollToFixed();

  $('#belt a[href*="#"]').on('click', function Amooth() {
    const bW = $('#belt .slider').width();
    if (this.hash !== '') {
      const { hash } = this;

      $('#belt a[href*="#"]').removeClass('active');
      $(this).addClass('active');

      $('html, body').stop().animate({
        scrollTop: $(hash).offset().top - beltH + 5,
      }, 800,
      () => {
        if (window.history.pushState) {
          window.history.pushState(null, null, hash);
        } else {
          window.location.hash = hash;
        }
      });
      return false;
    }
  });
}

function mobileNavScroll() {
  const $navHoles = $('#belt .holes');
  const $navSelect = $('#belt .select');
  $('#belt .select').on('click', () => {
    if ($navHoles.hasClass('active')) {
      $navHoles.removeClass('active');
    } else {
      $navHoles.addClass('active');
    }
  });
  $('#belt .slider a').on('click', function clickLink() {
    const sectionName = $(this).text();
    $navHoles.removeClass('active');
    $navSelect.find('span').text(sectionName);
  });
  $(window).scroll(() => {
    const unitName = $('#belt .slider li a.active').text();

    if (unitName !== '') {
      $('#belt .select span').text(unitName);
    }
  });
}

function initServiceSwiper(el) {
  // eslint-disable-next-line no-new
  return new Swiper(`${el} .swiper-container`, {
    slidesPerView: 1,
    centeredSlides: true,
    spaceBetween: 0,
    observer: true,
    observeParents: true,
    centerInsufficientSlides: true,
    navigation: {
      nextEl: `${el} .swiper-button-next`,
      prevEl: `${el} .swiper-button-prev`,
    },
    breakpoints: {
      768: {
        slidesPerView: 2,
        centeredSlides: false,
        spaceBetween: 0,
      },
      1140: {
        slidesPerView: 3,
        centeredSlides: false,
        spaceBetween: 0,
      },
    },
  });
}

$(document).ready(() => {
  let winWidth = window.innerWidth;
  let exclusiveSwiper = null;
  navScrollToFixed();
  mobileNavScroll();

  initServiceSwiper('#serviceSwiper');
  initServiceSwiper('#professionalSwiper');

  function initExclusiveSwiper() {
    if (winWidth < 1024 && exclusiveSwiper === null) {
      exclusiveSwiper = initServiceSwiper('#exclusiveSwiper');
    }
  }

  function exclusiveSwiperResize() {
    if (winWidth >= 1024 && exclusiveSwiper !== null) {
      exclusiveSwiper.destroy(true, true);
    }
  }

  initExclusiveSwiper();

  $(window).on('resize', () => {
    winWidth = window.innerWidth;
    exclusiveSwiperResize();
  });
});
